export default "__VITE_ASSET__DokOdqpn__"